module.exports = __webpack_public_path__ + "img/iconmonstr-email-10.4082623a.svg";